/**
 * Centralized date formatting utility.
 *
 * fmtDate(value)        → "23-07-2026"   (DD-MM-YYYY, date only — no time)
 * fmtDateTime(value)    → "23-07-2026 17:27"  (date + HH:MM, for audit logs)
 *
 * Accepts:
 *   - ISO 8601 strings: "2026-07-23T17:27:04.989521+00:00"
 *   - Partial ISO:      "2026-07-23"
 *   - Human dates:      "23 Jul 2026", "23 July 2026"
 *   - null / undefined / ""  → returns "—"
 */

/**
 * Format any date value to DD-MM-YYYY. Never shows time.
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function fmtDate(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  } catch {
    return String(value);
  }
}

/**
 * Format to DD-MM-YYYY HH:MM (for admin audit logs where time matters).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function fmtDateTime(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
  } catch {
    return String(value);
  }
}

export default fmtDate;
